import { render, staticRenderFns } from "./SwitchSideButton.vue?vue&type=template&id=5e642274&scoped=true&"
import script from "./SwitchSideButton.vue?vue&type=script&lang=js&"
export * from "./SwitchSideButton.vue?vue&type=script&lang=js&"
import style0 from "./SwitchSideButton.vue?vue&type=style&index=0&id=5e642274&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e642274",
  null
  
)

export default component.exports